import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { Invoice } from 'src/app/modelo/Invoice';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { InvoiceGlobal } from 'src/app/modelo/InvoiceGlobal';
import { validateDNIPattern } from 'src/app/shared/helpers';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { FacturasService } from '../facturas.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-factura-servicio-recibidas',
    templateUrl: './factura-servicio-recibidas.component.html',
    styleUrls: ['./factura-servicio-recibidas.component.scss']
})
export class FacturaServicioRecibidasComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    invoiceGlobal: InvoiceGlobal = new InvoiceGlobal();
    internalStatusInvoiceCountTotal: number = 0;
    facturas: Invoice[] = [];
    facturasSeleccionados: Invoice[];
    factura: Invoice = new Invoice();

    //Variables auxiliares
    cols: any[];
    multiSortMeta = [];
    enabledTotals: boolean = false;
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;
    tieneFacturas: boolean = false;
    buttonsActions: any[] = [];

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;

    //Compras registradas desde el SRI
    comprasRecibidas: any[] = [];

    //Diálogo de importación desde SRI
    mostrarImportar: boolean = false;
    clavesTexto: string = '';
    importando: boolean = false;

    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        private comprobantesService: ComprobantesService,
        private facturasService: FacturasService,
        private contactosService: ContactosService,
        private uiService: UIService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private sanitizer: DomSanitizer,
    ) {
        this.ui = uiService;
        moment.locale('es');
        this.cargarDataConstructor();

        this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_factura_recibida.pdf');
        this.pageDescription='Aquí se listarán las facturas que otros proveedores le hayan enviado a usted de manera automática, exclusívamente utilizando el sistema de FacturaFácil Ecuador. (En caso de que las facturas fueran generadas en otro sistema o plataforma, las facturas no se mostrarán en esta sección).';        
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Facturas Recibidas', routerLink: ['facturas/recibir'] }
        ]);
        this.cols = [
            { field: 'fechaEmision', header: 'Fecha de Emisión', visible: true },
            { field: 'secuencial', header: 'Secuencial', visible: true },
            { field: 'subjectFullName', header: 'Entidad', visible: true },
            { field: 'resumen', header: 'Resumen', visible: true },
            { field: 'importeTotal', header: 'Valor Total', visible: false, class: 'p-text-right' },
        ];
        this.multiSortMeta.push({ field: 'emissionOn', order: -1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.facturas = this.ui.updateDateFormatInvoice(await this.comprobantesService.getComprobantesParaUsuarioConectadoData());//Actualizar fechaEmission
        this.tieneFacturas = this.facturas.length > 0; //Para mostrar el buscador si hay en que buscar

        await this.cargarComprasRecibidas();

        this.cargandoDataInit = false;
    }

    async cargarComprasRecibidas() {
        this.comprasRecibidas = await this.comprobantesService.getComprasRecibidasData() || [];
    }

    /**
    ** Importación de comprobantes desde el SRI (por claves de acceso)
    **/
    abrirImportar() {
        this.clavesTexto = '';
        this.mostrarImportar = true;
    }

    importarDesdeSRI() {
        //Extraer todas las secuencias de 49 dígitos del texto pegado
        const claves = (this.clavesTexto.match(/\d{49}/g) || []);
        if (claves.length === 0) {
            this.ui.mostrarMensaje('warn', 'Pegue al menos una clave de acceso válida (49 dígitos).');
            return;
        }
        this.importando = true;
        this.comprobantesService.importarComprobantesSRI(claves).subscribe(
            async (res: any) => {
                this.importando = false;
                this.mostrarImportar = false;
                this.ui.mostrarMensaje('success',
                    `Importación: ${res.importadas} nuevas, ${res.yaExistian} ya existían, ${res.fallidas} con error (de ${res.total}).`);
                await this.cargarComprasRecibidas();
            },
            (err) => {
                this.importando = false;
                this.ui.mostrarError(err);
            }
        );
    }

    /**
    ** Métodos de formulario
    **/
    verTotalesFacturas(event, tipo: string) {
        if (tipo == 'main') {
            this.enabledTotals = !this.enabledTotals;
            let columnTotal = this.cols.find(item => item.field == 'importeTotal');
            columnTotal['visible'] = this.enabledTotals;
            this.cols[this.cols.indexOf(columnTotal)] = columnTotal;
        }
    }

}
